import http from '../../http'

const API_URL = "induction-program" 

class InductionProgramAPI {

  async save(program) {
    const response = await http(`${API_URL}/save`, 'POST', program)
    return response
  }

  async getAll(companyID, page) {
    const response = await http(`${API_URL}/${companyID}?page=${page}`)
    return response || null
  } 

  async get(programID) {
    const response = await http(`${API_URL}/show/${programID}`)
    return response.List || null
  }

  async getTema(companies_id) {
    const response = await http(`${API_URL}/training_name/${companies_id}`)
    return response || null
  }

  
  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response.List || null
  }

  async update(id, program) {
    const response = await http(`${API_URL}/edit/${id}`, 'PUT', program)
    return response
  }
    
}

export default new InductionProgramAPI()